import React from 'react';
import Layout from '../../../layouts/authorized';
import {apiHost} from '../../../common/config';
import axios from "axios";
import store from "../../../store/store";
import Button from "../../../components/UI/Button/Button";
import Select from "../../../components/UI/Select/Select";
import Modal from '../../../components/modal/modal';
import CustomTable from '../../../components/table/table.2.0';
import DatePickerRange from '../../../components/UI/DatePicker/DatePickerRange';

class Page extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            headers: [
                {code: 'date', caption: 'Дата', type: 'date'},
                {code: 'personalName', caption: 'ФИО', type: 'text'},
                {code: 'legalEntity', caption: 'Партнёр', type: 'text'},
                {code: 'legalAdresses', caption: 'Адрес', type: 'text'},
                {code: 'group', caption: 'Роль', type: 'text'},
                {code: 'source', caption: 'Источник', type: 'text'},
                {code: 'lens_group', caption: 'Группа', type: 'text'},
                {code: 'name', caption: 'Наименование', type: 'text'},
                {code: 'design', caption: 'Дизайн', type: 'text'},
                {code: 'covering', caption: 'Покрытие', type: 'text'},
                {code: 'count', caption: 'Кол-во линз', type: 'number'},
                {code: 'technology', caption: 'Технология', type: 'text'},
                {code: 'points', caption: 'Баллы', type: 'number'},
                {code: 'status', caption: 'Статус', type: 'text'},
            ],
            tableData: [],
            addresses: [
                {value: '', label: 'Все оптики'},
            ],
            subordinates: [
                {value: '', label: 'Все сотрудники'},
            ],
            entities: [
                {value: '', label: 'Все партнёры'},
            ],
            groups: [
                {value: '', label: 'Все роли'},
                {value: 'DOCTOR_USERS', label: 'Врач'},
                {value: 'CONSULTANT_USERS', label: 'Консультант'}
            ],
            filter: {
                legalEntity: '',
                group: '',
                address: '',
                subordinate: '',
                dateStart: '',
                dateEnd: '',
                limit: 10,
                page: 1,
            },
            searching: true,
            allRecords: 0,
        }

    }

    componentDidMount() {
        const {filter} = this.state;
        this.getTableData(filter);
        this.getEntities();
    }

    getTableData(filter) {
        axios.get(
            `${apiHost}/sale/get/sales`,
            {
                withCredentials: true,
                params: {
                    filter: JSON.stringify(filter)
                }
            }
        ).then(res => {
            this.setState({
                tableData: res.data.data,
                allRecords: res.data.allRecords
            });
        }).catch(error => {
            store.dispatch({
                type: 'addResponseStatus',
                status: error.response.data.error
            })
        }).finally(() => {
            this.setState({
                searching: false
            });
        });

    }

    getAddresses() {
        const {filter} = this.state;

        axios.get(
            `${apiHost}/entity/get/addresses/by/entity/${filter.legalEntity}`,
            {withCredentials: true,}
        ).then(res => {
            const { addresses } = this.state;
            this.setState({
                addresses: [...[{value: '', label: 'Все оптики'}], ...res.data]
            });
        }).catch(error => {
            store.dispatch({
                type: 'addResponseStatus',
                status: error.response.data.error
            })
        });

    }

    getSubordinates() {
        const {filter} = this.state;

        axios.get(
            `${apiHost}/user/get/subordinates/by/address/${filter.address}`,
            {withCredentials: true,}
        ).then(res => {
            const { subordinates } = this.state;
            this.setState({
                subordinates: [...[{value: '', label: 'Все сотрудники'}], ...res.data]
            });
        }).catch(error => {
            store.dispatch({
                type: 'addResponseStatus',
                status: error.response.data.error
            })
        });

    }

    getEntities() {
        axios.get(
            `${apiHost}/entity/getlist`,
            {withCredentials: true,}
        ).then(res => {
            const { entities } = this.state;
            this.setState({
                entities: [...entities, ...res.data]
            });
        }).catch(error => {
            store.dispatch({
                type: 'addResponseStatus',
                status: error.response.data.error
            })
        });

    }

    handleChangeGroup(selectedOption) {
        const {filter} = this.state;
        filter.group = selectedOption.value;
        this.setState({filter});
    }

    handleChangeAddress(selectedOption) {
        const {filter} = this.state;
        filter.address = selectedOption.value;
        this.setState({filter});

        this.checkIfNeedClearInputs('address');
        this.getSubordinates();
    }

    handleChangeSubordinate(selectedOption) {
        const {filter} = this.state;
        filter.subordinate = selectedOption.value;
        this.setState({filter});
    }

    handleChangeEntity(selectedOption) {
        const {filter} = this.state;
        filter.legalEntity = selectedOption.value;
        this.setState({filter});

        this.checkIfNeedClearInputs('legalEntity');
        this.getAddresses();
    }

    handleChangeDatePickerRange = (startDate, endDate) => {
        const {filter} = this.state;
        filter.dateStart = startDate;
        filter.dateEnd = endDate;
        this.setState({filter});
    }

    handleChangePage = (page) => {
        const {filter} = this.state
        filter.page = page;
        this.setState({
            searching: true
        });

        this.getTableData(filter);
    }

    handleSearch = () => {
        const {filter} = this.state;
        filter.page = 1;

        this.setState({
            searching: true
        });

        this.getTableData(filter);
    }

    checkIfNeedClearInputs = (field) => {
        const {filter} = this.state;

        if (field == 'legalEntity') {
            filter.address = '';
            filter.subordinate = '';
            filter.group = '';
        }

        if (field == 'address') {
            filter.subordinate = '';
            filter.group = '';
        }

        if (field == 'subordinate') {
        }

        this.setState({filter});

    }

    render() {
        const {filter} = this.state;

        return (
            <Layout>
                <h2 className="page-title">Продажи</h2>

                <div className="w-full md:flex md:justify-between md:w-3/4">
                    <div className="md:w-6/12 md:mr-5">
                        <Select
                            name="addresses"
                            label="Выберите партнёра"
                            placeholder="Все партнёры"
                            options={this.state.entities}
                            className="w-full"
                            onChange={(selectedOption) => this.handleChangeEntity(selectedOption)}
                            isDisabled={this.state.searching}
                        />
                    </div>
                    <div className="md:w-6/12 md:ml-5">
                        <Select
                            name="addresses"
                            label="Выберите адрес"
                            placeholder="Все оптики"
                            options={this.state.addresses}
                            className="w-full"
                            onChange={(selectedOption) => this.handleChangeAddress(selectedOption)}
                            isDisabled={this.state.searching || filter.legalEntity == ''}
                            value={this.state.addresses.filter((item) => item.value === filter.address)}
                        />
                    </div>
                </div>

                <div className="w-full md:flex md:justify-between md:w-3/4">
                    <div className="md:w-6/12 md:mr-5">
                        <Select
                            name="users"
                            label="Выберите сотрудника"
                            placeholder="Все сотрудники"
                            options={this.state.subordinates}
                            className="w-full"
                            onChange={(selectedOption) => this.handleChangeSubordinate(selectedOption)}
                            isDisabled={this.state.searching || filter.address == ''}
                            value={this.state.subordinates.filter((item) => item.value === filter.subordinate)}
                        />
                    </div>
                    <div className="md:w-6/12 md:ml-5">
                        <Select
                            name="groups"
                            label="Выберите роль"
                            placeholder="Все роли"
                            options={this.state.groups}
                            className="w-full"
                            onChange={(selectedOption) => this.handleChangeGroup(selectedOption)}
                            isDisabled={this.state.searching}
                            value={this.state.groups.filter((item) => item.value === filter.group)}
                        />
                    </div>
                </div>

                <div className="w-full md:flex md:justify-between md:w-3/4">
                    <div className="md:w-6/12 md:mr-5">
                        <DatePickerRange
                            onChange={this.handleChangeDatePickerRange}
                            isDisabled={this.state.searching}
                        />
                    </div>

                    <div className="md:w-6/12 md:ml-5"><br/></div>
                </div>
                <div className="w-full md:flex md:justify-between md:w-3/4 mb-10 mt-3">
                    <div className="md:w-6/12 md:mr-5">
                        <div className="w-full md:flex md:justify-between">
                            <button disabled={this.state.searching ? "disabled" : ""}
                                    className="btn btn-narrow btn-blue w-full md:w-6/12 md:mr-5"
                                    onClick={this.handleSearch}>Найти</button>

                        </div>
                    </div>

                    <div className="md:w-6/12 md:ml-5"></div>
                </div>


                {  this.state.tableData.length > 0 &&
                <CustomTable
                    headers={this.state.headers}
                    tableData={this.state.tableData}
                    showSpin={this.state.searching}
                    allRecords={this.state.allRecords}
                    perPage={this.state.filter.limit}
                    currentPage={this.state.filter.page}
                    onChangePage={this.handleChangePage}
                    exportLink={`${apiHost}/export/sales?filter=${JSON.stringify(this.state.filter)}`}
                />
                }

            </Layout>
        );
    }
}



export default Page;
